import { Warning, ArrowCounterClockwise, House } from '@phosphor-icons/react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

interface ErrorFallbackProps {
  page: string
}

export default function ErrorFallback({ page }: ErrorFallbackProps) {
  const { t } = useTranslation('components')
  return (
    <div data-page={page} className="min-h-screen flex items-center justify-center bg-riseup-black light:bg-gray-50 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="text-center max-w-md"
      >
        <motion.div
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20, delay: 0.1 }}
          className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-red-500/10 border border-red-500/20 flex items-center justify-center"
        >
          <Warning className="w-7 h-7 text-red-400" weight="duotone" />
        </motion.div>
        <h1 className="text-xl font-semibold text-white light:text-gray-900 mb-2">
          {t('error_fallback.title')}
        </h1>
        <p className="text-[var(--bn-text-muted)] light:text-gray-600 mb-8 text-sm leading-relaxed">
          {t('error_fallback.description')}
        </p>
        <div className="flex gap-3 justify-center">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => window.location.reload()}
            className="flex items-center gap-2 px-5 py-2.5 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors text-sm font-medium shadow-lg shadow-purple-500/20"
          >
            <ArrowCounterClockwise className="w-4 h-4" weight="regular" />
            {t('error_fallback.reload')}
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => { window.location.href = '/dashboard' }}
            className="flex items-center gap-2 px-5 py-2.5 bg-zinc-800 light:bg-gray-200 text-zinc-300 light:text-gray-700 rounded-xl hover:bg-zinc-700 light:hover:bg-gray-300 transition-colors text-sm font-medium"
          >
            <House className="w-4 h-4" weight="regular" />
            {t('error_fallback.dashboard')}
          </motion.button>
        </div>
      </motion.div>
    </div>
  )
}
